/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://yezsb5yfr5hvfn6yupkuz55etm.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-vs3dmqefl5bfdb2sadipu5hneu",
    "aws_cognito_identity_pool_id": "us-east-2:3487f4e5-097f-473b-bfb9-74d387034e81",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_wNA2fHmKy",
    "aws_user_pools_web_client_id": "1kqfggqd5hnn358jn5460g6snt",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "stepoutdatesimages223240-prod",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "geo": {
        "amazon_location_service": {
            "region": "us-east-2",
            "maps": {
                "items": {
                    "mapFirst-prod": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "mapFirst-prod"
            }
        }
    }
};


export default awsmobile;
